import {
  useLocaleStore,
} from "~/stores/locale";

export default defineNuxtPlugin({
  name: "i18n",
  setup() {
    const localeStore = useLocaleStore();

    // Initialize store on client side
    if (import.meta.client) {
      localeStore.initialize();
    }

    // Inject $t globally in templates
    return {
      provide: {
        t: (key: string, params?: Record<string, any>) => localeStore.t(key, params),
      },
    };
  },
});
